export default __webpack_public_path__ + "static/ISO-14001-BV-Logo-cf71b1dc9ea5fbbeb96e3bbe79c6af38.png";